const historicalMatchUpConfig = {
    "wnba":{
        "simple": [
            "date",
            "location",
            "win_loss",
            // "team_short_name",
            // "opponent_short_name",
            "team_score",
            "opponent_score",
            "team_assists",
            "opponent_assists",
            "team_blocks",
            "opponent_blocks",
            "team_steals",
            "opponent_steals",
            "team_three_point_field_goals_made",
            "opponent_three_point_field_goals_made",
            "team_total_rebounds",
            "opponent_total_rebounds",
            "team_turnovers",
            "opponent_turnovers",
            "team_field_goals_made",
            "opponent_field_goals_made",
            "team_free_throws_made",
            "opponent_free_throws_made",
            "team_offensive_rebounds",
            "opponent_offensive_rebounds"     
        ],
        "full": [
            "date",
            "location",
            "opponent_assists",
            "opponent_blocks",
            "opponent_field_goal_pct",
            "opponent_field_goals_attempted",
            "opponent_field_goals_made",
            "opponent_free_throw_pct",
            "opponent_free_throws_attempted",
            "opponent_free_throws_made",
            "opponent_name",
            "opponent_offensive_rebounds",
            "opponent_personal_fouls",
            "opponent_score",
            "opponent_steals",
            "opponent_three_point_field_goals_attempted",
            "opponent_three_point_field_goals_made",
            "opponent_three_point_pct",
            "opponent_total_rebounds",
            "opponent_turnovers",
            "season_year",
            "team_assists",
            "team_blocks",
            "team_field_goal_pct",
            "team_field_goals_attempted",
            "team_field_goals_made",
            "team_free_throw_pct",
            "team_free_throws_attempted",
            "team_free_throws_made",
            "team_offensive_rebounds",
            "team_personal_fouls",
            "team_score",
            "team_short_name",
            "team_steals",
            "team_three_point_field_goals_attempted",
            "team_three_point_field_goals_made",
            "team_three_point_pct",
            "team_total_rebounds",
            "team_turnovers",
            "win_loss"
        ]
    },
    "nfl":{
        "simple": [
            "week",
            "date",
            "day",
            "location",
            "team_short_name",
            "opponent",
            "result",
            "overtime",            
            "points_for",
            "points_against",            
            "passing_yards",
            "opp_passing_yards",
            "passing_tds",
            "opp_passing_tds",
            "rushing_yards",
            "opp_rushing_yards",
            "rushing_tds",
            "opp_rushing_tds",
            "total_plays",
            "opp_total_plays",
            "total_yards",
            "opp_total_yards",
            "yards_per_play",
            "opp_yards_per_play",
            "field_goals_made",
            "opp_field_goals_made",
            "extra_points_made",
            "opp_extra_points_made",
            "punts",
            "opp_punts",
            "penalties",
            "opp_penalties",
            "penalty_yards",
            "opp_penalty_yards",
            "fumbles_lost",
            "opp_fumbles_lost",
            "interceptions_thrown",
            "opp_interceptions_thrown",
            "total_turnovers",
            "opp_total_turnovers",
            "time_of_possession",
            "opp_time_of_possession",
        ],
        "full": [
            "rank",
            "game_number",
            "week",
            "date",
            "day",
            "location",
            "opponent",
            "result",
            "points_for",
            "points_against",
            "overtime",
            "pass_completions",
            "pass_attempts",
            "completion_pct",
            "passing_yards",
            "passing_tds",
            "passing_yards_per_attempt",
            "adj_passing_yards_per_attempt",
            "passer_rating",
            "sacks_taken",
            "net_passing_yards",
            "rush_attempts",
            "rushing_yards",
            "rushing_tds",
            "rushing_yards_per_attempt",
            "total_plays",
            "total_yards",
            "yards_per_play",
            "field_goal_attempts",
            "field_goals_made",
            "extra_point_attempts",
            "extra_points_made",
            "punts",
            "punt_yards",
            "first_downs_pass",
            "first_downs_rush",
            "first_downs_penalty",
            "total_first_downs",
            "third_down_conversions",
            "third_down_attempts",
            "fourth_down_conversions",
            "fourth_down_attempts",
            "penalties",
            "penalty_yards",
            "fumbles_lost",
            "interceptions_thrown",
            "total_turnovers",
            "time_of_possession",
            "team_short_name",
            "season_year",
            "points_allowed",
            "opp_pass_completions",
            "opp_pass_attempts",
            "opp_completion_pct",
            "opp_passing_yards",
            "opp_passing_tds",
            "opp_passing_yards_per_attempt",
            "opp_adj_passing_yards_per_attempt",
            "opp_passer_rating",
            "opp_sacks_taken",
            "opp_net_passing_yards",
            "opp_rush_attempts",
            "opp_rushing_yards",
            "opp_rushing_tds",
            "opp_rushing_yards_per_attempt",
            "opp_total_plays",
            "opp_total_yards",
            "opp_yards_per_play_attempt",
            "opp_field_goal_attempts",
            "opp_field_goals_made",
            "opp_extra_point_attempts",
            "opp_extra_points_made",
            "opp_punts",
            "opp_punt_yards",
            "opp_first_downs_pass",
            "opp_first_downs_rush",
            "opp_first_downs_penalty",
            "opp_total_first_downs",
            "opp_third_down_conversions",
            "opp_third_down_attempts",
            "opp_fourth_down_conversions",
            "opp_fourth_down_attempts",
            "opp_penalties",
            "opp_penalty_yards",
            "opp_fumbles_lost",
            "opp_interceptions_thrown",
            "opp_total_turnovers",
            "opp_time_of_possession",
            "statspyder_team_id"
        ]
    },
    "cfb":{},
    "nhl":{},
    "mlb":{},
    "mma":{}
}

export const getHistoricalMatchupColumns = (sportType, showFullStats) => {
    if(Object.keys(historicalMatchUpConfig).includes(sportType)) {
        if(showFullStats) {
            return historicalMatchUpConfig[sportType].full;
        }
        else {
            return historicalMatchUpConfig[sportType].simple;
        }
    }
    return null;
}